import { Typography } from '@mui/material'
import { useState } from 'react'
import { TableInventoryLists } from '../../components/TableInventoryLists/TableInventoryLists'
import * as S from './InventoryLists.styles'

const InventoryLists = () => {
  const [clickCreate, setClickCreate] = useState<boolean>(false)
  const [clickBadges, setClickBadges] = useState<boolean>(false)
  const [clickInventoryDetail, setClickInventoryDetail] = useState<boolean>(false)

  return (
    <S.Wrapper>
      {clickCreate ? <Typography variant='h5' fontWeight='bold'>Criar Lista de Inventário</Typography>
        : clickBadges ? <Typography variant='h5' fontWeight='bold'>Crachás habilitados para contagem de excedente</Typography>
          : clickInventoryDetail ? <Typography variant='h5' fontWeight='bold'>Detalhes do Inventário</Typography>
            : <Typography variant='h5' fontWeight='bold'>Listas de Inventário</Typography> }
      <TableInventoryLists
        clickCreate={clickCreate}
        setClickCreate={setClickCreate}
        clickBadges={clickBadges}
        setClickBadges={setClickBadges}
        clickInventoryDetail={clickInventoryDetail}
        setClickInventoryDetail={setClickInventoryDetail}
      />
    </S.Wrapper>
  )
}

export default InventoryLists
